import RequestAbstract from "./RequestAbstract";

export default class BonusMisty extends RequestAbstract {
    get link() {
        return this.links.bonusMisty;
    }

    async getBalanceForClient(clientId) {
        const res = await this.get(this.link + "/balance/" + clientId);
        return res;
    }

    async soft(invoiceId) {
        const res = await this.post(this.link + "/soft/" + invoiceId);
        return res;
    }

    async chargeUp(externalOrderId) {
        const res = await this.post(this.link + "/" + externalOrderId + "/charge-up");
        return res;
    }

    async writeDown(externalOrderId) {
        const res = await this.post(this.link + "/" + externalOrderId + "/write-down");
        return res;
    }

}
